import { render, staticRenderFns } from "./web.vue?vue&type=template&id=b87e1676&scoped=true"
var script = {}
import style0 from "./web.vue?vue&type=style&index=0&id=b87e1676&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87e1676",
  null
  
)

export default component.exports